import { render, staticRenderFns } from "./PriceRuleEditList.vue?vue&type=template&id=79ff00b1"
import script from "./PriceRuleEditList.vue?vue&type=script&lang=ts"
export * from "./PriceRuleEditList.vue?vue&type=script&lang=ts"
import style0 from "./PriceRuleEditList.vue?vue&type=style&index=0&id=79ff00b1&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79ff00b1')) {
      api.createRecord('79ff00b1', component.options)
    } else {
      api.reload('79ff00b1', component.options)
    }
    module.hot.accept("./PriceRuleEditList.vue?vue&type=template&id=79ff00b1", function () {
      api.rerender('79ff00b1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/price-rules/PriceRuleEditList.vue"
export default component.exports